<template>
    <div class="container">

        <div class="row h2 m-4">
            <span>Change Password</span>
        </div>
        <div class="row text-primary m-4 justify-content-center" >
            <div class="col-6 col-sm-2 text-left">
                <span> Old Password</span>
            </div>
            <div class="col-6 col-sm-2">
                <input type="password" class="col-12" v-model="oldPassword" placeholder="Enter Old Password"/>
            </div>
        </div>

        <div class="row text-primary m-4 justify-content-center" >
            <div class="col-6 col-sm-2 text-left">
                <span> New Password</span>
            </div>
            <div class="col-6 col-sm-2">
                <input type="password" class="col-12" v-model="newPassword" placeholder="Enter New Password"/>
            </div>
        </div>

        <div class="row text-primary m-4 justify-content-center" >
            <div class="col-6 col-sm-2 text-left">
                <span> Confirm Password</span>
            </div>
            <div class="col-6 col-sm-2">
                <input type="password" class="col-12" v-model="confirmPassword" placeholder="Confirm New Password"/>
            </div>
        </div>
        <div>
            <button @click="changePassword">Change Password</button>
        </div>
        <div class="row h3 text-success" v-show="isPasswordChangeSuccessful == 'true'">
            <span>Password Changed Successfully</span>
        </div>
        <div class="row h3 text-danger" v-show="isPasswordChangeSuccessful == 'false'">
            <span>Password Could not be Changed</span>
        </div>

</div>
</template>
<script lang="ts">
import { ref } from "vue";

export default({
    name:"changePassword",
    props:['baseUrl', 'userId'],
    setup(props:any){
        const oldPassword = ref('');
        const newPassword = ref('');
        const confirmPassword = ref('');
        const isPasswordChangeSuccessful = ref('');

        const changePassword = ()=>{
            isPasswordChangeSuccessful.value = '';
            //console.log("props.baseUrl " , props.baseUrl);
            //console.log("props.userId " , props.userId);


            if(newPassword.value != confirmPassword.value)
            {
                alert("Enter new-password does not match the confirm-password. Please enter same password in both places.");
                return;
            }
            let token = localStorage.getItem("Guardtoken");
            //console.log("token ", token);
            let userLoginId = localStorage.getItem("UserLoginId") as string;
            //console.log("userLoginId ", userLoginId);

            let requestUrl = props.baseUrl + "login/ChangeGuardUserPassword";
            let requestContents={
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bearer ${token}`
                },
                body: JSON.stringify({
                    NewPassword:newPassword.value,
                    UserPb : {
                        UserId: parseInt(userLoginId),// props.userId,
                        Password : oldPassword.value,
                        UserName:"ABAD"
                    },
                }),
            };
            fetch(requestUrl, requestContents)
            .then(response => {
                let res = response.json();
                //console.log("res ", res);
                return res;
            })
            .then( res => {
                //console.log("res " , res);
                if(res.loginResultUserViewModel == null)
                    isPasswordChangeSuccessful.value = 'false';
                else
                    isPasswordChangeSuccessful.value = 'true';
            });
        }

        return{
            oldPassword,
            newPassword,
            confirmPassword,
            isPasswordChangeSuccessful,
            changePassword
        }
    },
});
</script>